import Joi from 'joi';
import { rutValidation } from '../../../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  serialNumber: Joi.string()
    .pattern(/^[A-Za-z0-9]{9}$/)
    .error(new Error('Debe contener 9 caracteres alfanuméricos.')),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  email: Joi.string()
    .email({ minDomainSegments: 2, tlds: {} })
    .error(new Error('Formato de correo inválido.')),
  motiveClient: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar una opción')),
  comment: Joi.string().min(10).max(250).messages({
    'string.min': 'Tu comentario debe tener al menos 10 caracteres.',
    'string.max': 'Tu comentario no puede superar los 250 caracteres.',
    'string.empty': 'El comentario no puede estar vacío.',
  }),
});
